import * as constants from '../constants/map';


const initialState = {
    selectedMap: null,
    availableMaps: [],
    renderer: constants.RENDERER_SVG,
    origin: null,
    destination: null,
    selectedPOI: null,
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.LOAD_MAP:
            return {
                ...state,
                selectedMap: action.selectedMap
            };
        
        case constants.SET_AVAILABLE_MAPS:
            return {
                ...state,
                availableMaps: action.maps
            };
        
        case constants.SET_SELECTED_MAP:
            return {
                ...state,
                selectedMap: action.map
            };
        
        case constants.SET_RENDERER:
            return {
                ...state,
                renderer: action.renderer
            }
        
        case constants.SET_DESTINATION:
            return {
                ...state,
                destination: action.destination
            }

        case constants.SET_ORIGIN:
            return {
                ...state,
                origin: action.origin
            }

        case constants.SET_SELECTED_POI:
            return {
                ...state,
                selectedPOI: action.selectedPOI
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/map.js